"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useThrottleFn = void 0;

var React = __importStar(require("react"));

var use_unmount_1 = require("./use-unmount");

function useThrottleFn(fn, args, ms) {
  if (ms === void 0) {
    ms = 200;
  }

  var _a = React.useState(null),
      state = _a[0],
      setState = _a[1];

  var timeout = React.useRef();
  var nextArgs = React.useRef();
  React.useEffect(function () {
    if (!timeout.current) {
      setState(fn.apply(void 0, args));

      var timeoutCallback_1 = function timeoutCallback_1() {
        if (nextArgs.current) {
          setState(fn.apply(void 0, nextArgs.current));
          nextArgs.current = undefined;
          timeout.current = setTimeout(timeoutCallback_1, ms);
        } else {
          timeout.current = undefined;
        }
      };
    }
  }, args);
  use_unmount_1.useUnmount(function () {
    if (timeout.current) {
      clearTimeout(timeout.current);
    }
  });
  return state;
}

exports.useThrottleFn = useThrottleFn;